<script setup lang="ts">
import { computed } from 'vue';
import { useLanguageStore } from '@/shared/stores/languageStore';
import { getLanguageFlagUrl } from '@/utils/locales/messages';

// 언어 스토어 사용
const languageStore = useLanguageStore();

// 지원 언어 목록 자동 로드
const supportedLanguages = computed(() => {
  const languages = languageStore.supportedLanguages.value;
  console.log('🌐 LanguageDD - Supported languages from store:', languages);

  const mappedLanguages = languages.map(lang => ({
    title: lang.nativeName,
    subtext: lang.name,
    value: lang.code,
    avatar: getLanguageFlagUrl(lang.code, 20)
  }));
  
  console.log('🌐 LanguageDD - Mapped languages for dropdown:', mappedLanguages);
  return mappedLanguages;
});

// 현재 선택된 언어의 플래그
const getCurrentFlag = (locale: string): string => {
  const lang = supportedLanguages.value.find(l => l.value === locale);
  return lang?.avatar || '';
};
</script>
<template>
    <!-- ---------------------------------------------- -->
    <!-- language DD -->
    <!-- ---------------------------------------------- -->
    <v-menu open-on-click location="bottom">
        <template v-slot:activator="{ props }">
            <v-btn icon variant="text" color="primary" v-bind="props" size="small" class="custom-hover-primary" >
                <v-avatar rounded="md">
                    <img
                        v-if="getCurrentFlag(languageStore.currentLanguage.value)"
                        :src="getCurrentFlag(languageStore.currentLanguage.value)"
                        :alt="languageStore.currentLanguage.value"
                        width="22"
                        height="15"
                        class="obj-cover"
                    />
                    <span v-else class="text-caption">{{ languageStore.currentLanguage.value.toUpperCase() }}</span>
                </v-avatar>
            </v-btn>
        </template>
        <v-sheet rounded="md" width="360" elevation="10">
            <v-list class="theme-list">
                <v-list-item
                    v-for="(item, index) in supportedLanguages"
                    :key="index"
                    color="primary"
                    :active="languageStore.currentLanguage.value == item.value"
                    class="d-flex align-center"
                    @click="() => {
                      console.log('🌐 LanguageDD - Clicked language:', item.value);
                      languageStore.setLanguage(item.value);
                    }"
                >
                    <template v-slot:prepend>
                        <v-avatar rounded="md">
                            <img
                                v-if="item.avatar"
                                :src="item.avatar"
                                :alt="item.value"
                                width="22"
                                height="15"
                                class="obj-cover"
                            />
                            <span v-else class="text-caption">{{ item.value.toUpperCase() }}</span>
                        </v-avatar>
                    </template>
                    <v-list-item-title class="lang-row">
                        <span class="lang-title">
                          {{ item.title }}
                        </span>
                        <span class="lang-subtext">
                          {{ item.subtext }}
                        </span>
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-sheet>
    </v-menu>
</template>

<style scoped>
.lang-row {
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  gap: 10px;
  line-height: 1.2;
}

.lang-title {
  font-size: 14px; /* 기존보다 조금 크게 */
  font-weight: 500;
  color: rgba(0, 0, 0, 0.88);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 190px; /* subtext 공간 확보 */
}

.lang-subtext {
  font-size: 13px; /* caption보다 크게 */
  font-weight: 400;
  color: rgba(0, 0, 0, 0.55);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1 auto;
  min-width: 0;
}
</style>
